import { registerTourPage } from '@/composables/tour/tourRegistry';
import { step, introStep } from '@/composables/tour/stepHelpers';

registerTourPage('admin-teacher', {
  key: 'admin-teacher',
  label: 'Staff',
  getSteps: () => [
    step({
      target: '#tour-teachers-invite-btn',
      title: 'Invite Staff',
      content:
        'Send an email invitation to a staff member or admin. They\'ll receive a link to set their password and join the school.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-teachers-search',
      title: 'Find Staff',
      content:
        'Search by name or email, and choose how many staff to display per page.',
      placement: 'bottom',
    }),
    step({
      target: '#tour-teachers-grid',
      title: 'Staff Cards',
      content:
        'Each card shows a staff member with their status, role, and contact info. Click any card to open their full profile and manage their classes, subjects, and permissions.',
      placement: 'top',
    }),
  ],
});

registerTourPage('teacher-details', {
  key: 'teacher-details',
  label: 'Staff Details',
  getSteps: () => [
    introStep({
      title: 'Staff Profile',
      content:
        'Profile, assigned subjects, and (for tertiary) lecturer courses. Use the action buttons to update assignments or request a role change.',
    }),
  ],
});
